const MONTH_FORMATTER = new Intl.DateTimeFormat('es-PA', { month: 'long', year: 'numeric' });

/** 'YYYY-MM' -> a calendar month label ('julio de 2026'); null means never covered. */
export function formatMonthLabel(periodMonth: string | null): string {
  if (!periodMonth) return 'Sin pagos';
  const [year, month] = periodMonth.split('-').map(Number);
  if (!year || !month) return periodMonth;
  return MONTH_FORMATTER.format(new Date(year, month - 1, 1));
}
